const complainInterface = document.getElementById("ccw-complain-interface");
const form = document.getElementById("ccw-complain-interface-form");
const errorSummary = document.getElementById("ccw-error-summary");
const letter = document.getElementById("ccw-complain-interface-letter");
const results = document.getElementById("ccw-complain-interface-results");
const editButton = document.getElementById("ccw-edit-complain-form");
const charactersLimitInputs = document.querySelectorAll(
  ".form__input-characters-limit"
);

if (form) {
  ccwValidateComplainForm();
  ccwComplainFormsSrollToError();
  ccwEditComplainForm();
  ccwMaxCharLimit();
  ccwCheckInputChoice();
}

// function scroll to error.
function ccwComplainFormsSrollToError() {
  if (errorSummary) {
    const errorLinks = errorSummary.querySelectorAll(".form__error-link");
    errorLinks.forEach((errorLink) => {
      errorLink.addEventListener("click", (event) => {
        event.preventDefault();
        const href = errorLink.getAttribute("href");
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: "smooth",
          });
        }
        const firstInput = target.querySelector("input, textarea, select");
        if (firstInput) {
          firstInput.focus();
        }
      });
    });
  }
}

//function to validate input forms and show error messages.
function ccwValidateComplainForm() {
  form.addEventListener("submit", function (event) {
    event.preventDefault();
    let isValid = true;
    const requiredInputs = document.getElementsByClassName(
      "form__field-mandatory"
    );
    const errorItems = document.querySelectorAll(".form__error-list-item");
    for (let errorItem of errorItems) {
      errorItem.classList.remove("form__error-list-item--show");
    }

    for (let input of requiredInputs) {
      input.classList.remove("form__text--error");
      const parent = input.closest(".form__field-wrapper");
      if (parent) {
        const label = parent.querySelector(".form__label");
        label.classList.remove("form__label--error");
      }
      const inputValTrim = input.value.trim();
      if (inputValTrim == "") {
        input.classList.add("form__text--error");
        const parent = input.closest(".form__field-wrapper");
        const label = parent.querySelector(".form__label");
        label.classList.add("form__label--error");

        const errorItem = document.querySelector(
          ".form__error-list-item[data-error='" + input.name + "']"
        );
        errorItem.classList.add("form__error-list-item--show");
        isValid = false;
      }

      if (input.type == "radio") {
        const radios = Array.from(document.getElementsByName(input.name));

        const checkedRadio = radios.find((radio) => radio.checked);

        for (let radio of radios) {
          const parent = radio.closest(".form__fieldset");
          const label = parent.querySelector(".form__legend");
          if (!checkedRadio) {
            radio.classList.add("form__input-radio--error");
            label.classList.add("form__legend--error");
            const errorItem = document.querySelector(
              ".form__error-list-item[data-error='" + input.name + "']"
            );
            errorItem.classList.add("form__error-list-item--show");
            isValid = false;
          } else {
            radio.classList.remove("form__input-radio--error");
            label.classList.remove("form__legend--error");
          }
        }
      }
    }

    if (!isValid && errorSummary) {
      errorSummary.classList.add("form__error-summary--show");
      errorSummary.scrollIntoView({
        behavior: "smooth",
      });
      errorSummary.querySelector(".form__error-link").focus();
    } else {
      if (errorSummary) {
        errorSummary.classList.remove("form__error-summary--show");
      }
      ccwCreateLetterTemplate();
      form.classList.add("ccw-complain-interface__form--hide");
      results.classList.add("ccw-complain-interface__results--show");
      complainInterface.scrollIntoView({
        behavior: "smooth",
      });
    }
  });
}

function ccwCreateLetterTemplate() {
  const inputs = Array.from(form.elements);
  const getMarks = letter.querySelectorAll("[data-answer]");
  const hideEmptyMarksParent = letter.querySelectorAll(
    ".ccw-complain-interface__mark-empty"
  );

  getMarks.forEach((emptyMark) => {
    emptyMark.textContent = "";
  });

  inputs.forEach(function (input) {
    const name = input.name;
    const value = input.value;

    if (value) {
      const marks = letter.querySelectorAll(`[data-answer="${name}"]`);

      marks.forEach(function (mark) {
        if (input.tagName === "TEXTAREA") {
          const valueWithBr = value.replace(/\n/g, "<br>");
          mark.innerHTML = valueWithBr;
        } else if (input.type === "radio") {
          if (input.checked) {
            let relatedInputValueCheck = input.getAttribute("data-letter-value")
              ? input.getAttribute("data-letter-value")
              : "";
            if (
              value.trim().toLowerCase() ===
              relatedInputValueCheck.trim().toLowerCase()
            ) {
              let relatedInput = document.querySelector(
                `input[data-choice-required="${name}"]`
              );
              if (relatedInput) {
                mark.textContent = relatedInput.value;
              }
            } else {
              mark.textContent = value;
            }
          }
        } else {
          mark.textContent = value;
        }
      });
    }
  });

  const paragraphs = document.querySelectorAll("p");

  paragraphs.forEach((paragraph) => {
    const marks = paragraph.querySelectorAll("mark");
    const allMarksEmpty = [...marks].some(
      (mark) => mark.textContent.trim() === ""
    );

    if (allMarksEmpty) {
      paragraph.classList.add(
        "ccw-complain-interface__remove-line-if-empty--hide"
      );
    } else {
      paragraph.classList.remove(
        "ccw-complain-interface__remove-line-if-empty--hide"
      );
    }

    // Get all data attributes of the paragraph
    const dataAttributes = Array.from(paragraph.attributes).filter((attr) =>
      attr.name.startsWith("data-choice")
    );

    // Iterate over each data attribute
    dataAttributes.forEach((attr) => {
      const choiceName = attr.name;
      const valName = choiceName.replace("choice", "change-value");

      const choiceValue = paragraph.getAttribute(choiceName);
      const valValue = paragraph.getAttribute(valName);

      // If choiceValue is present, proceed to check the input value
      if (choiceValue) {
        const inputElement = document.querySelector(
          `input[name="${choiceValue}"]:checked`
        );
        const inputElementVal = inputElement
          ? inputElement.value.trim().toLowerCase()
          : "no";
        if (inputElementVal === valValue.trim().toLowerCase()) {
          paragraph.classList.add(
            "ccw-complain-interface__remove-line-if-empty--hide"
          );
        }
      }
    });
  });

  // const paragraphs = letter.querySelectorAll("p");

  // // Iterate over each paragraph
  // paragraphs.forEach((paragraph) => {
  //   // Find all mark elements within the paragraph
  //   const marks = paragraph.querySelectorAll("mark");
  //   const paragraphDataChoice = paragraph.getAttribute("data-choice") || "";
  //   const paragraphDataChoiceTwo =
  //     paragraph.getAttribute("data-choice-two") || "";
  //   const paragraphDataChoiceVal =
  //     paragraph.getAttribute("data-choice-val") || "";
  //   const paragraphDataChoiceValTwo =
  //     paragraph.getAttribute("data-choice-val-two") || "";
  //   // Initially remove the hide class
  //   paragraph.classList.remove(
  //     "ccw-complain-interface__remove-line-if-empty--hide"
  //   );

  //   // Check if every mark is empty
  //   const allMarksEmpty = Array.from(marks).some(
  //     (mark) => mark.textContent.trim() === ""
  //   );

  //   // If all marks are empty, add the hide class
  //   if (allMarksEmpty) {
  //     paragraph.classList.add(
  //       "ccw-complain-interface__remove-line-if-empty--hide"
  //     );
  //   }

  //   // If paragraphDataChoice is present, proceed to check the input value
  //   if (paragraphDataChoice || paragraphDataChoiceTwo) {
  //     const inputElement = document.querySelector(
  //       `input[name="${paragraphDataChoice}"]:checked`
  //     );
  //     const inputElementTwo = document.querySelector(
  //       `input[name="${paragraphDataChoiceTwo}"]:checked`
  //     );
  //     // Ensure the input element exists before trying to access its value
  //     if (inputElement || inputElementTwo) {
  //       const inputVal = inputElement
  //         ? inputElement.value.trim().toLowerCase()
  //         : "";
  //       const inputValTwo = inputElementTwo
  //         ? inputElementTwo.value.trim().toLowerCase()
  //         : "";
  //       if (
  //         inputElement &&
  //         inputVal.trim().toLowerCase() ===
  //           paragraphDataChoiceVal.trim().toLowerCase()
  //       ) {
  //         paragraph.classList.add(
  //           "ccw-complain-interface__remove-line-if-empty--hide"
  //         );
  //       }
  //       if (
  //         inputElementTwo &&
  //         inputValTwo.trim().toLowerCase() ===
  //           paragraphDataChoiceValTwo.trim().toLowerCase()
  //       ) {
  //         paragraph.classList.add(
  //           "ccw-complain-interface__remove-line-if-empty--hide"
  //         );
  //       }
  //     }
  //   }
  // });
  // getMarks.forEach(function (mark) {
  //   const parentElement = mark.closest(
  //     ".ccw-complain-interface__remove-line-if-empty"
  //   );

  //   if (parentElement) {
  //     parentElement.classList.toggle(
  //       "ccw-complain-interface__remove-line-if-empty--hide",
  //       !mark.textContent.trim()
  //     );
  //   }
  // });

  // hideEmptyMarksParent.forEach(function (mark) {
  //   const parentElement = mark.closest(
  //     ".ccw-complain-interface__remove-line-if-empty"
  //   );

  //   if (parentElement) {
  //     parentElement.classList.toggle(
  //       "ccw-complain-interface__remove-line-if-empty--hide",
  //       !mark.textContent.trim()
  //     );
  //   }
  // });
}
//function to edit the letter form.
function ccwEditComplainForm() {
  editButton.addEventListener("click", function (e) {
    e.preventDefault();
    form.classList.remove("ccw-complain-interface__form--hide");
    results.classList.remove("ccw-complain-interface__results--show");
    const firstInput = form.querySelector("input, textarea, select");
    if (firstInput) {
      firstInput.focus();
    }
  });
}

//function to check Max character limit.
function ccwMaxCharLimit() {
  charactersLimitInputs.forEach((textarea) => {
    textarea.addEventListener("input", function (e) {
      const textarea = e.target;
      const maxCharacters = parseInt(
        textarea.getAttribute("data-max-chararacters"),
        10
      );
      if (maxCharacters) {
        const currentCharacters = textarea.value.length;
        const charCountSpan = textarea.nextElementSibling.querySelector(
          ".form__characters-number"
        );
        charCountSpan.textContent = `${Math.min(
          currentCharacters,
          maxCharacters
        )}/${maxCharacters}`;
        if (currentCharacters >= maxCharacters) {
          textarea.value = textarea.value.slice(0, maxCharacters);
          charCountSpan.classList.add("form__characters-number--error");
        } else {
          charCountSpan.classList.remove("form__characters-number--error");
        }
      }
    });
  });
}

function ccwCheckInputChoice() {
  const inputChoices = document.querySelectorAll(".form__input-radio");

  inputChoices.forEach(function (radio) {
    radio.addEventListener("change", function () {
      let value = this.value.trim().toLowerCase();
      const relatedInputs = document.querySelectorAll(
        `input[data-choice-required="${this.name}"]`
      );

      if (relatedInputs) {
        relatedInputs.forEach((relatedInput) => {
          let relatedInputValueCheck = relatedInput.getAttribute(
            "data-choice-val"
          )
            ? relatedInput.getAttribute("data-choice-val")
            : "";
          const parent = relatedInput.closest(".form__field-wrapper");
          const checkGroup = relatedInput.closest(".form__field-check-group");

          if (value === relatedInputValueCheck) {
            if (
              relatedInput.classList.contains("form__field-mandatory--check")
            ) {
              relatedInput.classList.add("form__field-mandatory");
            }
            if (checkGroup) {
              checkGroup.classList.remove("form__field-check-group--hide");
            }
          } else {
            if (
              relatedInput.classList.contains("form__field-mandatory--check")
            ) {
              relatedInput.classList.remove(
                "form__field-mandatory",
                "form__text--error"
              );
            }
            if (parent && checkGroup) {
              const label = parent.querySelector(".form__label");
              checkGroup.classList.add("form__field-check-group--hide");
              label.classList.remove("form__label--error");
            }
          }
        });
      }
    });
  });
}
